<div class="flex gap-2 w-full">
  <!-- Month Dropdown -->
  <div class="relative flex-1" #monthContainer>
    <input
      type="text"
      class="form-input cursor-pointer dob-input-field"
      [class.opacity-50]="isDOBValid"
      [class.cursor-not-allowed]="isDOBValid"
      [placeholder]="this.labels.MONTH"
      [value]="selectedMonth || ''"
      [disabled]="isDOBValid"
      (click)="!isDOBValid && toggleDropdown('month')"
      (focus)="!isDOBValid && toggleDropdown('month')"
      readonly
    />
    <div
      class="w-full border border-[color:var(--gray-100,#e8e8e8)] shadow-[0_4px_13px_#ababab14] rounded-[0_0_8px_8px] border-solid absolute top-[25px] z-10 bg-[#fff] max-h-[200px] overflow-hidden overflow-y-auto"
      [@stateOrCountryDropdownAnimation]
      *ngIf="showMonthDropdown && !isDOBValid"
    >
      <div
        class="h-full flex flex-col"
        *ngFor="let month of months"
        (click)="selectMonth(month)"
        (keydown.enter)="selectMonth(month)"
        tabindex="0"
        [class.bg-gray-100]="selectedMonth === month"
        class="px-4 py-2 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0"
      >
        {{ month }}
      </div>
    </div>
  </div>

  <!-- Day Dropdown -->
  <div class="relative flex-1" #dayContainer>
    <input
      type="text"
      class="form-input cursor-pointer dob-input-field"
      [class.opacity-50]="isDOBValid"
      [class.cursor-not-allowed]="isDOBValid"
      [placeholder]="this.labels.DAY"
      [value]="selectedDate || ''"
      [disabled]="isDOBValid"
      (click)="!isDOBValid && toggleDropdown('day')"
      (focus)="!isDOBValid && toggleDropdown('day')"
      readonly
    />
    <div
      class="w-full border border-[color:var(--gray-100,#e8e8e8)] shadow-[0_4px_13px_#ababab14] rounded-[0_0_8px_8px] border-solid absolute top-[25px] z-10 bg-[#fff] max-h-[200px] overflow-hidden overflow-y-auto"
      [@stateOrCountryDropdownAnimation]
      *ngIf="showDayDropdown && !isDOBValid"
    >
      <div
        class="h-full flex flex-col"
        *ngFor="let date of dates"
        (click)="selectDay(date)"
        (keydown.enter)="selectDay(date)"
        tabindex="0"
        [class.bg-gray-100]="selectedDate === date"
        class="px-4 py-2 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0"
      >
        {{ date }}
      </div>
    </div>
  </div>

  <!-- Year Dropdown -->
  <div class="relative flex-1" #yearContainer>
    <input
      type="text"
      class="form-input cursor-pointer dob-input-field"
      [class.opacity-50]="isDOBValid"
      [class.cursor-not-allowed]="isDOBValid"
      [placeholder]="this.labels.YEAR"
      [value]="selectedYear || ''"
      [disabled]="isDOBValid"
      (click)="!isDOBValid && toggleDropdown('year')"
      (focus)="!isDOBValid && toggleDropdown('year')"
      readonly
    />
    <div
      class="w-full border border-[color:var(--gray-100,#e8e8e8)] shadow-[0_4px_13px_#ababab14] rounded-[0_0_8px_8px] border-solid absolute top-[25px] z-10 bg-[#fff] max-h-[200px] overflow-hidden overflow-y-auto"
      [@stateOrCountryDropdownAnimation]
      *ngIf="showYearDropdown && !isDOBValid"
    >
      <div
        class="h-full flex flex-col"
        *ngFor="let year of years"
        (click)="selectYear(year)"
        (keydown.enter)="selectYear(year)"
        tabindex="0"
        [class.bg-gray-100]="selectedYear === year"
        class="px-4 py-2 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0"
      >
        {{ year }}
      </div>
    </div>
  </div>
</div>
